import {HttpUser} from "../../http/user/httpUser";
import {navigationHelper} from "./navigationHelper";
import {userStorage} from "../localStorage/userStorage";

export const logoutHelper = async function onClickLogOut() {
    
    HttpUser.logOut()
        .finally(() => {
                userStorage.removeFromStorage()
                window.location.href = navigationHelper.to("login")
            }
        )
}